<template>
  <div class="activities">
    <div style="padding-top:5%;">
    <!-- <div class="page-header"> -->
      <div>
      <h1>Vue.js 2 & Firebase <small>Sample Application by CodingTheSmartWay.com</small></h1>
    </div>
    <div class="panel panel-default">
      <div class="panel-heading">
        <h3 class="panel-title">Add New Books</h3>
      </div>
      <div class="panel-body">
         <form id="form" class="form-inline" v-on:submit.prevent="addBook"><br>
          <div class="form-group" style="text-align:center;">
            <label for="bookTitle">Title:</label>
            <input type="text" id="bookTitle" class="form-control" v-model="newBook.title">
          </div>
          <div class="form-group">
            <label for="bookAuthor">Author:</label>
            <input type="text" id="bookAuthor" class="form-control" v-model="newBook.author">
          </div>
          <div class="form-group">
            <label for="bookUrl">Url:</label>
            <input type="text" id="bookUrl" class="form-control" v-model="newBook.url">
          </div>
          <input type="submit" class="btn btn-primary" value="Add Book">
        </form>
      </div>
    </div>
    <div class="panel panel-default">
      <div class="panel-heading">
        <h3 class="panel-title">Book List</h3>
      </div>
      <div class="panel-body">
        <table class="table table-striped">
          <thead>
            <tr>
              <th>Title</th>
              <th>Author</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="book in books">
              <td><a v-bind:href="book.url">{{book.title}}</a></td>
              <td>{{book.author}}</td>
              <td><span class="glyphicon glyphicon-trash" aria-hidden="true" v-on:click="removeBook(book)"></span></td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <b-button @click="logout" variant="outline-danger" class="btn btn-lg">
      <icon name="sign-out-alt"></icon> Log out</b-button>
  </div>
</div>
</template>
<script>
// import firebase from 'firebase'
import db from '../db'

import toastr from 'toastr'


let booksRef = db.ref('books')


export default {
  name: 'Activities',
  data () {
    return {
      newBook: {
          title: '',
          author: '',
          url: 'http://'
      },
      books: [],
    }
  },
  firebase: {
    books: db.ref('books'),
  },
  methods: {
    onSubmit(evt) {
      evt.preventDefault()
      alert(JSON.stringify(this.form))
    },
    onReset(evt) {
      evt.preventDefault()
      // Reset our form values
      this.form.id = ''
      this.form.passwd = ''
      this.show = false
      this.$nextTick(() => {
        this.show = true
      })
    },
    logout: function() {
      firebase.auth().signOut().then(() => {
        this.$router.replace('login')
      })
    },
    addBook: function () {
        booksRef.push(this.newBook);
        this.newBook.title = '';
        this.newBook.author = '';
        this.newBook.url = 'http://';
      },
      removeBook: function (book) {
   booksRef.child(book['.key']).remove()
   toastr.success('Book removed successfully')
 }
  }

}

</script>
<style>
* {
  margin: 0;
  padding: 0;
  list-style: none;
}

.activities {
  background-color: rgba(248, 194, 88,0.1);
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  padding-bottom: 15%;

}

/*html,body{
  height:100%;
  display: flex;
  justify-content: center;
  align-items: center;
}*/
.login1 {
  margin-top: 100px;
  margin-bottom: 100px;
  width: 500px;
  height: 400px;
  background-color: rgba(#FFFFFF);
  border-radius: 10px;
  /*border: 5px solid #fff;*/
  box-shadow: 0 0 25px #aaa;
  backdrop-filter: blur(5px);
  display: flex;
  justify-content: center;
  -ms-align-items: center;
  align-items: center;
}

.form {

  /*color: #fff;*/
}

.form h2 {
  margin-bottom: 20px;
  padding-bottom: 20px;
  /*border-bottom: 1px solid #fff;*/
}

.form .group {
  margin-bottom: 20px;
}

.form label {

  line-height: 2;

}

.form input {
  width: 100%;
  border: 1px solid #aaa;
  line-height: 3;
  border-radius: 5px;
}

.form .btn-group {
  font-size: 0;
}

.btn1 {
  font-size: 20px;
  border-radius: 10px;
  border: none;
  background-color: #6ab4fe;
  width: 190px;
  padding: 10px 0;
  color: #fff;
  /*margin-left: 20px;*/

}

.form .btn+.btn {
  margin-left: 20px;
}

</style>
